/**
 * @file src/const/layout.ts
 * @exports FULL_PAGE_LAYOUT_CONTENT_WIDTH, NAV_HEIGHT, USER_CONTROLS_HEIGHT
 * @summary Shared content width and navigation and user control heights.
 */

// While not used by FullPageLayout, this is the recommended max width for the content.
export const FULL_PAGE_LAYOUT_CONTENT_WIDTH = 1188;
export const NAV_HEIGHT = 94;
export const USER_CONTROLS_HEIGHT = 72;
